/* ADDED FILE */
/* UNTAPPED - ORDER SWATCH BUTTON */

/**
 * Code to process the click of Order Swatch and add the swatch variant to the basket.
 * 
 * There are a couple of possible approaches to this - we need to both add the basket, 
 * and update the UI, ie the count of items in the cart, and arguably open the cart 
 * drawer as when using Add to Cart.
 * 
 * One approach is to temporarily change the id of the Add to Cart and click that.  This
 * works well, but the button is visually updated, ie spinner and colour change, and this 
 * looks odd when you didn't click tha button.
 * 
 * The alternative is to duplicate what Kalles does and repeate the differnet steps.  This 
 * is the apporoach taken 
 * 
 * This js relies on the global swatch map at window.the_stripes_company.product_page.swatch_map.
 * This provides a map, based on the product being displayed, from each variant id for the product
 * to the corresponding colourway variant on the swatch product.
 */


/**
 * Main click handler for Order Swatch buttons
 */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.add-swatch-btn');
  if (!btn) return;

  if (btn.getAttribute('aria-busy') === 'true') return;
  e.preventDefault();

  const productVariantId = getCurrentVariantId();
  if (!productVariantId) {
    console.warn('[Order Swatch] No selected variant');
    return;
  } 

  const swatchVariantId = getSwatchVariantForProductVariant(productVariantId);

  if (!swatchVariantId) {
    console.warn('[Order Swatch] No swatch for variant', productVariantId);
    return;
  }

  btn.setAttribute('aria-busy', 'true');
  btn.setAttribute('disabled', 'true');
  btn.classList.add('is-loading');

  try {
    const data = await addSwatchToCart(swatchVariantId);
    updateCartDrawerFromResponse(data);
    await updateHeaderCartIndicators(data);
    openCartDrawer();

  } catch (err) {
    console.error('Failed to add swatch to cart', err);
    alert(err?.description || err?.message || 'Unable to add swatch');
  } finally {
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('disabled');
    btn.classList.remove('is-loading');
  }
});

function getSwatchVariantForProductVariant(variantId) {
  const swatchMap = window.the_stripes_company?.product_page?.swatch_map;
  if (!swatchMap) return null;

  return swatchMap[variantId] || null;
}

function getCurrentVariantId() {
  const form = document.querySelector('.hdt-main-product-form');
  if (!form) return null;

  const input = form.querySelector('input[name="id"]');
  return input?.value || null;
}

/**
 * Add an item to the cart
 */
async function addSwatchToCart(variantId) {
  const sectionId = getCartDrawerSectionId();

  const payload = {
    id: variantId,
    quantity: 1
  };

  // Ask Shopify to return cart drawer section HTML, rendered for the current template
  if (sectionId) {
    payload.sections = sectionId; // asks shopify to return the cart html
    payload.sections_url = window.location.pathname;  // used to derive the template
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    const err = await res.json();
    throw err;
  }

  return res.json();
}



/**
 * Find the cart drawer section ID used by Kalles
 * Example:
 *   sections--27812096278859__cart-drawer
 */
function getCartDrawerSectionId() {
  const el = document.querySelector('[id^="shopify-section-"][id*="cart"]');
  if (!el) return null;
  return el.id.replace('shopify-section-', '');
}


/**
 * Inject returned section HTML into the DOM
 * (This is exactly what Kalles does internally)
 */
function updateCartDrawerFromResponse(data) {
  if (!data || !data.sections) return;

  Object.entries(data.sections).forEach(([sectionId, html]) => {
    const container = document.getElementById(`shopify-section-${sectionId}`);
    if (container) {
      container.innerHTML = html;
    }
  });
}

/**
 * Open the Kalles cart drawer, by clicking on the icon in the page
 */
function openCartDrawer() {
  // Try common Kalles cart triggers
  const cartButton =
    document.querySelector('[data-cart-toggle]') ||
    document.querySelector('.hdt-cart-icon') ||
    document.querySelector('a[href="/cart"]') ||
    document.querySelector('[href="/cart"]');

  if (cartButton) {
    cartButton.click();
  } else {
    console.warn('Cart toggle button not found');
  }
}

async function updateHeaderCartIndicators(data) {
  if (!data) return;

  // Update item count
  const countEl = document.querySelector('hdt-cart-count');
  if (countEl && typeof data.quantity === 'number') {
    countEl.textContent = data.quantity;
    countEl.toggleAttribute('hidden', data.quantity === 0);
  }

// The folowing code updates the cart total - it isn't displayed in my testing, but maybe it will be
// needed in future, so it left commented out
//   // Update price
//   const totalEl = document.querySelector('hdt-cart-total');
//   if (totalEl && typeof data.total_price === 'number') {
//     totalEl.textContent = (data.total_price / 100).toLocaleString(
//       Shopify.locale || 'en-GB',
//       { style: 'currency', currency: Shopify.currency.active }
//     );
//     totalEl.classList.toggle('hdt-hidden', data.item_count === 0);
//   }
}


